const randomString = (length = 32) => {
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  const maxPos = chars.length;
  let pwd = '';
  for (let i = 0; i < length; i += 1) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};
const getSuffix = (filename = '') => {
  const pos = filename.lastIndexOf('.');
  let suffix = '';
  if (pos !== -1) {
    suffix = filename.substring(pos);
  }
  return suffix;
};

// 生成oss名称
const getOSSFileName = (fileName: string) => {
  return `${randomString()}${new Date().getTime()}${getSuffix(fileName)}`;
};

export default getOSSFileName;
